import { Outlet } from "react-router-dom"
import AppBarComponent from "../AppBar/AppBar"
import { Footer } from "../Footer/Footer"
import { SideBar } from "../SideBar/SideBar"
import "./styles.scss"
import {Box} from '@mui/material';
import {SideBarMobile} from '../SideBarMobile';
import {SetPasswordModal} from '../SetPasswordModal';
import {useSelector} from 'react-redux';
import {useEffect} from 'react';

export const SidebarAndAppbarLayout = () => {
    const isVisible = useSelector((state: any) => state.generalStore.visibleSideBar);
    // Tells the floating Terms & Privacy button to hide: the side menus carry it here.
    useEffect(() => {
        document.body.classList.add('cy-has-app-sidebar');
        return () => document.body.classList.remove('cy-has-app-sidebar');
    }, []);
    return (
        <div>
            <Box sx={isVisible ? { filter: "blur(2px)", pointerEvents: "none", overflow: "hidden", maxHeight: "100vh" } : {}}>
                <AppBarComponent/>
                <Box className="sidebar-and-appbar-layout">
                    <Box 
                        className="sidebar-and-appbar-layout__sidebar-container" 
                        sx={{
                            display: {xs: 'none', md: 'block'},
                            position: 'sticky',
                            top: { xs: '56px', md: '77px' },
                            height: { xs: 'calc(100vh - 56px)', md: 'calc(100vh - 77px)' },
                            zIndex: 1150
                        }}
                    >
                        <SideBar/>
                    </Box>

                    <div className="sidebar-and-appbar-layout__appbar-container">
                        <Outlet/>
                        <Footer/>
                    </div>
                </Box>
            </Box>
            <SideBarMobile/>
            <SetPasswordModal/>
        </div>
    );
}
